import { Link } from "react-router-dom";
import useTitle from "./useTitle";

// AdSense program policy requires a privacy policy that discloses that
// Google and its partners use cookies to serve ads; GA4 needs the same for
// analytics. Keep this page in step with what src/config.js switches on.
const Privacy = () => {
    useTitle("私隱政策 Privacy Policy｜Math-EXE");
    return (
    <div className="topic-page privacy">
        <h1>私隱政策</h1>
        <h2 className="topic-en">Privacy Policy</h2>
        <p className="crumb">最後更新：2026 年 10 月</p>

        <h3>我們收集甚麼</h3>
        <p>
            Math-EXE（math-exe.com）不設會員登記，瀏覽及下載練習毋須提供任何個人資料。
            如你自願在「新練習上線通知」填寫電郵地址，我們只會用它來通知你新練習推出，
            不會出售或轉交第三方，你可隨時要求刪除。
        </p>

        <h3>分析工具：Google Analytics</h3>
        <p>
            本網站使用 Google Analytics 4 了解哪些課題最多人瀏覽及下載，以決定下一步編寫甚麼練習。
            Google Analytics 會使用 Cookie 收集匿名的使用數據，例如瀏覽的頁面、裝置類型及大概地區，
            不會收集你的姓名或電郵。詳情見{" "}
            <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noreferrer">
                Google 如何使用合作夥伴網站的資料
            </a>。
        </p>

        <h3>廣告：Google AdSense</h3>
        <p>
            為維持免費提供練習，本網站可能透過 Google AdSense 展示廣告。
            第三方供應商（包括 Google）會使用 Cookie，根據你過往瀏覽本網站或其他網站的紀錄投放廣告。
            Google 使用廣告 Cookie，令它及其合作夥伴可以根據你瀏覽本網站及／或互聯網上其他網站的紀錄，向你展示廣告。
        </p>
        <p>
            你可前往{" "}
            <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">Google 廣告設定</a>{" "}
            停用個人化廣告，或前往{" "}
            <a href="https://www.aboutads.info/choices/" target="_blank" rel="noreferrer">www.aboutads.info</a>{" "}
            停用第三方供應商使用 Cookie 投放個人化廣告。
        </p>

        <h3>Cookie 的控制</h3>
        <p>
            你可以在瀏覽器設定中封鎖或刪除 Cookie。封鎖後，本網站的練習及下載功能不受影響。
        </p>

        <h3>聯絡我們</h3>
        <p>
            對本政策有任何疑問，或想刪除你提供的電郵地址，請電郵至{" "}
            <a href="mailto:mathexe0@gmail.com">mathexe0@gmail.com</a>。
        </p>

        <p><Link to="/">返回首頁</Link></p>
    </div>
    );
};

export default Privacy;
